import { render, staticRenderFns } from "./IpProject.vue?vue&type=template&id=0f000f44&scoped=true&"
import script from "./IpProject.vue?vue&type=script&lang=js&"
export * from "./IpProject.vue?vue&type=script&lang=js&"
import style0 from "./IpProject.vue?vue&type=style&index=0&id=0f000f44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f000f44",
  null
  
)

export default component.exports